import React from 'react';
import { Modal, Button } from '@appkit4/react-components';

/**
 * Warning modal for editing start date
 */
export const EditStartDateWarningModal = ({ show, onConfirm, onCancel }) => (
  <Modal
    title="Warning"
    ariaLabel="Edit Start Date Warning"
    visible={show}
    onCancel={onCancel}
    modalStyle={{ width: '600px' }}
    footer={
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
        <Button kind="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button kind="primary" onClick={onConfirm}>
          Proceed
        </Button>
      </div>
    }
  >
    <p>
      Revising the start date to an earlier period may require revisions to the Group Information 
      (NGIE/ANGIE/QNGIE/Group EBITDA) in the earlier period. It is recommended that the prior period 
      is edited unless the election was made (and included in a CIR return) in a prior period but has 
      not previously been reflected in the CIR Analyser.
    </p>
  </Modal>
);

/**
 * Warning modal for main edit/delete action (when electionSubmitted = Yes)
 */
export const MainEditDeleteWarningModal = ({ show, onConfirm, onCancel }) => (
  <Modal
    title="Warning"
    ariaLabel="Edit Delete Warning"
    visible={show}
    onCancel={onCancel}
    modalStyle={{ width: '600px' }}
    footer={
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
        <Button kind="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button kind="primary" onClick={onConfirm}>
          Proceed
        </Button>
      </div>
    }
  >
    <p>
      The Consolidated Partnership election is an irrevocable election and therefore edits should 
      only be made here in certain circumstances (e.g. to reflect name changes, or that the 
      partnership has been disposed of).
    </p>
  </Modal>
);

/**
 * Warning modal for editing disposal date
 */
export const EditDisposalDateWarningModal = ({ show, onConfirm, onCancel }) => (
  <Modal
    title="Warning"
    ariaLabel="Edit Disposal Date Warning"
    visible={show}
    onCancel={onCancel}
    modalStyle={{ width: '600px' }}
    footer={
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
        <Button kind="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button kind="primary" onClick={onConfirm}>
          Proceed
        </Button>
      </div>
    }
  >
    <p>
      Revising the disposal date to an earlier period may require revisions to the Group Information 
      (NGIE/ANGIE/QNGIE/Group EBITDA) in the earlier period. It is recommended that the prior period 
      is edited unless the disposal was reflected in a CIR return in a prior period (i.e. the 
      partnership was not included in that return) but has not previously been reflected in the CIR Analyser.
    </p>
  </Modal>
);

/**
 * Warning modal for deleting a partnership (when electionSubmitted = Yes)
 */
export const DeletePartnershipWarningModal = ({ show, onConfirm, onCancel }) => (
  <Modal
    title="Warning"
    ariaLabel="Delete Partnership Warning"
    visible={show}
    onCancel={onCancel}
    modalStyle={{ width: '600px' }}
    footer={
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
        <Button kind="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button kind="danger" onClick={onConfirm}>
          Delete Partnership
        </Button>
      </div>
    }
  >
    <p>
      The Consolidated Partnership election is irrevocable and therefore the delete button should 
      only be used in limited circumstances where the election was incorrectly included in a previous 
      period and it has been agreed with HMRC that any previous returns including the election were invalid.
    </p>
    <p style={{ marginTop: '16px' }}>
      If the partnership no longer exists as it has been disposed of, please reflect this by selecting 
      the disposed of button.
    </p>
  </Modal>
);
